import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

import { sendBulkMails } from '@/api';

import { ISendBulkEmailPayload } from '@/interface';

interface MailState {
  loading: boolean;
  error: string | null;
}
const initialState: MailState = {
  loading: false,
  error: null,
};

//create role
export const sendBulkMailRequest = createAsyncThunk<
  unknown,
  { data: ISendBulkEmailPayload; navigate: (path: string) => void },
  { rejectValue: string }
>('email/sendBulkMail', async ({ data, navigate }, { rejectWithValue }) => {
  try {
    const response = await sendBulkMails(data);
    navigate('/projects');
    return response.data;
  } catch (error) {
    const message = axios.isAxiosError(error) ? (error.response?.data as { message?: string } | undefined)?.message : undefined;
    return rejectWithValue(message || 'not sent email');
  }
});

export const mailSlice = createSlice({
  name: 'mail',
  initialState,
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // handle all roles
      .addCase(sendBulkMailRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendBulkMailRequest.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(sendBulkMailRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      });
  },
});
